import { render } from "./NotAuthorized.vue?vue&type=template&id=5a49ce62&ts=true"
import script from "./NotAuthorized.vue?vue&type=script&lang=ts"
export * from "./NotAuthorized.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__